























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Liff extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show?: boolean

  @Watch('show')
  onShowChange(newValue: boolean) {
    if (newValue) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
}
